/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';

// use HYDRATE when server action is used
// https://www.youtube.com/watch?v=bpbLq6NxIm8&ab_channel=MayankSrivastava
// import { HYDRATE } from 'next-redux-wrapper';

import { syncPosition } from './actions';

export interface State {
    position: {
        x: number;
        y: number;
    };
    selectedCity: string;
}

const initialState: State = {
    position: {
        x: 0,
        y: 0,
    },
    selectedCity: '',
};

export const reducer = createReducer(initialState, (builder) => {
    builder.addCase(syncPosition, (state, action) => {
        state.value += action.payload;
    });
});
